import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KeyMappingService {
  public handleKeyPress(
    event: KeyboardEvent,
    buttons: any[],
    onButtonClick: (button: any) => void
  ): void {
    if (!this.isValidKey(event.key)) {
      return;
    }
    const buttonId = this.mapKey(event.key);
    if (buttonId === -1) {
      return;
    }
    const button = buttons.find((b) => b.id === buttonId);
    if (button) {
      onButtonClick(button);
      event.preventDefault();
    }
  }

  private isValidKey(key: string): boolean {
    return this.validKeys.includes(key);
  }

  private validKeys: string[] = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
  ];

  private mapKey(key: string): number {
    switch (key) {
      case '0':
        return 13;
      case '1':
        return 0;
      case '2':
        return 1;
      case '3':
        return 2;
      case '4':
        return 4;
      case '5':
        return 5;
      case '6':
        return 6;
      case '7':
        return 8;
      case '8':
        return 9;
      case 'ArrowUp':
        return 1;
      case 'ArrowDown':
        return 9;
      case 'ArrowLeft':
        return 4;
      case 'ArrowRight':
        return 6;
      default:
        return -1;
    }
  }
}
